jQuery(function($){
    function updateScoreText(score){
        $('#rewards').html(score)
    }
    $('#ptdf-posts').on('click', '.show-comments-btn', function() {
        let postId = $(this).data('post-id')

        let $commentsArea = $('#comments-for-' + postId)
        let $commentsForm = $('#comment-form-' + postId)
        $commentsForm.stop(true, true).slideToggle()
    })
    $('#ptdf-posts').on('click', '.ptdf-reply-btn', function(){
        console.log('click on reply')
        var $btn = $(this)
        var parentId = $btn.data('parent-id')
        var postId = $btn.data('post-id')
        var $area = $btn.closest('.comment').find('.reply-form-area')
        let image_icon = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><!--!Font Awesome Free v7.0.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M160 144C151.2 144 144 151.2 144 160L144 480C144 488.8 151.2 496 160 496L480 496C488.8 496 496 488.8 496 480L496 160C496 151.2 488.8 144 480 144L160 144zM96 160C96 124.7 124.7 96 160 96L480 96C515.3 96 544 124.7 544 160L544 480C544 515.3 515.3 544 480 544L160 544C124.7 544 96 515.3 96 480L96 160zM224 192C241.7 192 256 206.3 256 224C256 241.7 241.7 256 224 256C206.3 256 192 241.7 192 224C192 206.3 206.3 192 224 192zM360 264C368.5 264 376.4 268.5 380.7 275.8L460.7 411.8C465.1 419.2 465.1 428.4 460.8 435.9C456.5 443.4 448.6 448 440 448L200 448C191.1 448 182.8 443 178.7 435.1C174.6 427.2 175.2 417.6 180.3 410.3L236.3 330.3C240.8 323.9 248.1 320.1 256 320.1C263.9 320.1 271.2 323.9 275.7 330.3L292.9 354.9L339.4 275.9C343.7 268.6 351.6 264.1 360.1 264.1z"/></svg>';

        // If already open, close
        if($area.children().length) { $area.empty(); return; }
        // Only one open at a time for clarity (optional)
        $('.reply-form-area').empty()

        var formHtml = `
            <form class="mt-2 ptdf-add-comment-form ptdf-reply-form" data-post-id="${postId}" data-parent-id="${parentId}">
                <div class="mb-2">
                    <textarea name="content" class="form-control" rows="2" placeholder="Responder..." required></textarea>
                </div>
                <input type="file" accept="image/*" class="ptdf-image-file" style="display:none;">
                                        <div class="d-flex align-items-center gap-2 mb-2">

                                            <div class="ptdf-image-preview" style="display:none; align-items:center; gap:8px;">
                                                <img alt="" class="ptdf-preview-img" style="max-height:80px; border-radius:6px;">
                                                <button type="button" class="btn btn-outline-danger btn-sm ptdf-remove-image">X</button>
                                            </div>
                                        </div>
                <div class="d-flex ptdf-comments-btns">
                
                <button type="submit" class="btn btn-secondary btn-sm">Responder</button>
                <button type="button" class="btn btn-sm ptdf-add-image">${image_icon}</button>
                <button type="button" class="btn btn-danger btn-sm ptdf-cancel-reply">Cancelar</button>
</div>
                
                <div class="comment-form-feedback mt-2"></div>
            </form>
        `
        $area.html(formHtml);
    })


    $('#ptdf-posts').on('click', '.ptdf-cancel-reply', function(){
        $(this).closest('.reply-form-area').empty();
    })
    $('#ptdf-posts').on('click', '.show-more-comments', function(e){
        e.preventDefault()
        let postId = $(this).data('post-id')
        let $commentsArea = $('.comments[data-post-id="' + postId + '"]')
        $(this).remove()
        $.ajax({
            url: ptdfNetworkAjax.ajaxurl,
            type: 'POST',
            dataType: 'json',
            data: {
                action: 'ptdf_get_post_comments',
                post_id: postId,
                nonce: ptdfNetworkAjax.nonce
            },
            success: function(resp){
                if(resp.success){

                    $commentsArea.append(resp.data.html)
                }else{
                    $commentsArea.html('<div class="text-danger">Error loading comments.</div>');
                }
            },
            error: function(){
                $commentsArea.html('<div class="text-danger">Error connecting to server.</div>');
            }
        });
    })
    $('#ptdf-posts').on('click', '.show-more-replies', function(e){
        e.preventDefault()
        let postId = $(this).data('post-id')
        let $commentsArea = $('.comment[data-comment-id="' + postId + '"]')
        $(this).remove()
        $.ajax({
            url: ptdfNetworkAjax.ajaxurl,
            type: 'POST',
            dataType: 'json',
            data: {
                action: 'ptdf_show_children_comments',
                post_id: postId,
                nonce: ptdfNetworkAjax.nonce
            },
            success: function(resp){
                if(resp.success){
                    $commentsArea.after(resp.data.html)
                }else{
                    $commentsArea.html('<div class="text-danger">Error loading comments.</div>');
                }
            },
            error: function(){
                $commentsArea.html('<div class="text-danger">Error connecting to server.</div>');
            }
        })
    })

    $('#ptdf-posts').on('submit', '.ptdf-add-comment-form', function(e){
        e.preventDefault()
        let $form = $(this)
        let postId = $form.data('post-id')
        let content = $form.find('textarea[name="content"]').val()
        let parentId = $form.data('parent-id') || 0
        let $feedback = $form.find('.comment-form-feedback')
        let $commentsArea = $form.closest('.post-comments-area')
        // For replies, update the whole comments area
        if($form.hasClass('ptdf-reply-form')) {
            $commentsArea = $form.closest('.post-comments-area')
        }

        const file = $form.data('pickedFile') || $form.data('pastedFile') || null

        const fd = new FormData();
        fd.append('action', 'ptdf_add_post_comment');
        fd.append('post_id', postId);
        fd.append('content', content);
        fd.append('parent_id', parentId);
        fd.append('nonce', ptdfNetworkAjax.nonce);

        if (file) {
            // give it a stable name
            const ext = (file.type && file.type.split('/')[1]) || 'png';
            fd.append('file', file, `comment-${Date.now()}.${ext}`);
        }

        $feedback.text('');
        $form.find('button[type="submit"]').prop('disabled', true);

        $.ajax({
            url: ptdfNetworkAjax.ajaxurl,
            type: 'POST',
            data: fd,
            dataType: 'json',
            processData: false,   // IMPORTANT for FormData
            contentType: false,   // IMPORTANT for FormData
            success: function(resp){
                $form.find('button[type="submit"]').prop('disabled', false);
                if(resp.success){
                    const score = resp.data.score
                    if(typeof score === 'number'){
                        updateScoreText(score)
                    }
                    $commentsArea.html(resp.data.html);
                }else{
                    $feedback.html('<span class="text-danger">'+(resp.data || 'Error adding comment')+'</span>');
                }
            },
            error: function(){
                $form.find('button[type="submit"]').prop('disabled', false)
                $feedback.html('<span class="text-danger">Error connecting to server.</span>')
            }
        })
    })

    function showPreview($form, file){
        const url = URL.createObjectURL(file);
        $form.find('.ptdf-preview-img').attr('src', url);
        $form.find('.ptdf-image-preview').css('display','flex');
        // Revoke later when form re-renders (your success replaces the DOM anyway)
    }

    // Paste (single image)
    $('#ptdf-posts').on('paste', 'textarea', function(e){
        const data = e.originalEvent.clipboardData || e.clipboardData;
        if (!data || !data.items) return;
        const $form = $(this).closest('form.ptdf-add-comment-form');
        console.log('paste:', data)
        // already have an image? respect single-image rule
        if ($form.data('pastedFile') || $form.data('pickedFile')) return;

        for (let i=0;i<data.items.length;i++){
            const it = data.items[i];
            if (it.kind === 'file' && it.type.startsWith('image/')){
                const file = it.getAsFile();
                if (file){
                    $form.data('pastedFile', file);
                    showPreview($form, file);
                }
                break;
            }
        }
    });

    // “Add image” button
    $('#ptdf-posts').on('click', '.ptdf-add-image', function(){
        const $form = $(this).closest('form.ptdf-add-comment-form');
        $form.find('.ptdf-image-file').trigger('click');
    });

    // File chosen
    $('#ptdf-posts').on('change', '.ptdf-image-file', function(){
        const $form = $(this).closest('form.ptdf-add-comment-form');
        const file = this.files && this.files[0];
        if (!file) return;

        // single-image policy: replace any pasted/picked
        $form.removeData('pastedFile');
        $form.data('pickedFile', file);
        showPreview($form, file);

        // allow picking same file again
        $(this).val('');
    });

    // Remove image
    $('#ptdf-posts').on('click', '.ptdf-remove-image', function(){
        const $form = $(this).closest('form.ptdf-add-comment-form');
        $form.removeData('pastedFile').removeData('pickedFile');
        $form.find('.ptdf-preview-img').attr('src','');
        $form.find('.ptdf-image-preview').hide();
        $form.find('.comment-form-feedback').text('Imagem removida.');
    });

})